import { ProviderDetails } from '../../redux/providerBuilder/providerDetails/types';
import { SelectedInstanceType } from '../../redux/providerBuilder/selectedInstances';

function search(
  path: string,
  obj: any,
  target: string,
  matches: { path: string; key: string; isString: boolean }[] = [],
  isArray = false
) {
  for (var k in obj) {
    if (obj.hasOwnProperty(k)) {
      if (typeof obj[k] === 'undefined') {
        continue;
      }

      let newPath = path + '.' + k;
      if (typeof obj[k] === 'object') {
        if (isArray) {
          newPath = path + '[' + k + ']';
        }

        if (Array.isArray(obj[k])) {
          search(newPath, obj[k], target, matches, true);
        } else {
          search(newPath, obj[k], target, matches);
        }
      } else if (obj[k].toString().includes(target)) {
        matches.push({
          path: path + '.' + k,
          key: k,
          isString: typeof obj[k] === 'string',
        });
      }
    }
  }

  return matches;
}

function escapeRegExp(text: any) {
  return text.replace(/[-[\]{}()*+?.,\\^$|#]/g, '\\$&');
}

function createXPathFromElement(elm: any, doc: any) {
  const allNodes = doc.getElementsByTagName('*');
  let i = 0;
  let sib;
  for (var segs = []; elm && elm.nodeType === 1; elm = elm.parentNode) {
    if (elm.hasAttribute('id')) {
      var uniqueIdCount = 0;
      for (var n = 0; n < allNodes.length; n++) {
        if (allNodes[n].hasAttribute('id') && allNodes[n].id === elm.id) {
          uniqueIdCount++;
        }

        if (uniqueIdCount > 1) {
          break;
        }
      }

      if (uniqueIdCount === 1) {
        segs.unshift('id("' + elm.getAttribute('id') + '")');
        return segs.join('/');
      } else {
        segs.unshift(
          elm.localName.toLowerCase() + '[@id="' + elm.getAttribute('id') + '"]'
        );
      }
    } else if (elm.hasAttribute('class')) {
      segs.unshift(
        elm.localName.toLowerCase() + '[@class="' + elm.getAttribute('class') + '"]'
      );
    } else {
      for (i = 1, sib = elm.previousSibling; sib; sib = sib.previousSibling) {
        if (sib.localName === elm.localName) {
          i++;
        }
      }

      segs.unshift(elm.localName.toLowerCase() + '[' + i + ']');
    }
  }

  return segs.length ? '/' + segs.join('/') : null;
}

function getMatchIndexes(str: string, toMatch: string | RegExp) {
  try {
    var re = new RegExp(toMatch, 'g'),
      indexMatches = [],
      match;

    while ((match = re.exec(str))) {
      indexMatches.push(match.index);
    }

    return indexMatches;
  } catch (e) {
    console.log(e);
    return [];
  }
}

function getValuePositionInJson(
  jsonString: string,
  jsonPath: string,
  searchString: string,
  posList: Array<number>
): number {
  try {
    const jsonObject = JSON.parse(jsonString);
    jsonPath = jsonPath.slice(2);
    const keys = jsonPath.split('.');
    const keyType = keys.map((key) => {
      if (key.includes('[')) {
        return {
          type: 'array',
          key: key.split('[')[0],
          index: key.split('[')[1].split(']')[0],
        };
      } else {
        return { type: 'object', key };
      }
    });
    let pos = 0;
    let currentObject = jsonObject;
    let partialString = '';
    for (let i = 0; i < keyType.length; i++) {
      let currPos = 0;
      const key = keyType[i].key;
      const index = keyType[i]?.index ?? 0;
      if (currentObject[key]) {
        partialString =
          keyType[i].type === 'object'
            ? JSON.stringify(currentObject[key])
            : JSON.stringify(currentObject[key][index]);
        const jsonCurrentString = JSON.stringify(currentObject);
        currentObject =
          keyType[i].type === 'object' ? currentObject[key] : currentObject[key][index];

        currPos = jsonCurrentString.indexOf(partialString, 0);

        let tempCurrPos =
          typeof currentObject === 'string'
            ? pos + currPos + 1
            : typeof currentObject === 'number'
              ? pos + currPos
              : -1;

        while (posList.includes(tempCurrPos) && i === keyType.length - 1) {
          currPos = jsonCurrentString.indexOf(partialString, currPos + 1);
          tempCurrPos =
            typeof currentObject === 'string'
              ? pos + currPos + 1
              : typeof currentObject === 'number'
                ? pos + currPos
                : -1;
        }

        pos += currPos;
      }
    }

    const currPos = partialString.indexOf(searchString, 0);
    pos += currPos;

    return pos;
  } catch (e) {
    console.log(e);
    return -1;
  }
}

function getUniqueItems(arr: string[]): string[] {
  return Array.from(new Set(arr));
}

// function getAllPaths(
// 	path: string,
// 	obj: any,
// 	target: string,
// 	matches: { [path: string]: boolean } = {},
// 	isArray = false
// ) {
// 	for (var k in obj) {
// 		if (obj.hasOwnProperty(k)) {
// 			if (typeof obj[k] === 'undefined') {
// 				continue
// 			}

// 			const newPath = isArray ? `${path}[${k}]` : `${path}.${k}`

// 			if (typeof obj[k] === 'object') {
// 				if (Array.isArray(obj[k])) {
// 					matches[newPath] = true
// 					getAllPaths(newPath, obj[k], target, matches, true)
// 				} else {
// 					matches[newPath] = true
// 					getAllPaths(newPath, obj[k], target, matches)
// 				}
// 			} else if (obj[k].toString().includes(target)) {
// 				matches[newPath] = true
// 			}
// 		}
// 	}

// 	return matches
// }

function getAllPaths(
  path: string,
  obj: any,
  target: string,
  matches: { [path: string]: boolean } = {},
  isArray = false
) {
  for (var k in obj) {
    if (obj.hasOwnProperty(k)) {
      if (typeof obj[k] === 'undefined') {
        continue;
      }

      let newPath;
      if (path === '') {
        if (isNaN(parseInt(k))) {
          newPath = isArray ? `[${k}]` : `.${k}`;
        } else {
          newPath = isArray ? `[${k}]` : `[${k}]`;
        }
      } else {
        newPath = isArray ? `${path}[${k}]` : `${path}.${k}`;
      }

      if (typeof obj[k] === 'object') {
        if (Array.isArray(obj[k])) {
          matches[newPath] = true;
          getAllPaths(newPath, obj[k], target, matches, true);
        } else {
          matches[newPath] = true;
          getAllPaths(newPath, obj[k], target, matches);
        }
      } else if (obj[k].toString().includes(target)) {
        matches[newPath] = true;
      }
    }
  }

  return matches;
}

function getAllDynamicPaths(
  path: string,
  obj: any,
  target: string,
  matches: { [path: string]: string } = {},
  isArray = false,
  clickedPath: string,
  checked: boolean = false
) {
  for (var k in obj) {
    if (obj.hasOwnProperty(k)) {
      if (typeof obj[k] === 'undefined') {
        continue;
      }

      const newPath = isArray ? `${path}[${k}]` : `${path}.${k}`;

      let matchedTxt = '';
      if (obj[k]?.toString()?.includes('{{REQ_BODY_')) {
        matchedTxt = `{{REQ_BODY_${Object.keys(matches)?.length + 1}}}`;
      }

      if (obj[k]?.toString()?.includes('{{REQ_SECRET_')) {
        matchedTxt = `{{REQ_SECRET_${Object.keys(matches)?.length + 1}}}`;
      }

      if (path + '.' + k === clickedPath) {
        if (checked) {
          matchedTxt = `{{REQ_SECRET_${Object.keys(matches)?.length + 1}}}`;
        } else {
          if (obj[k].toString().includes('{{REQ_BODY_')) {
            matchedTxt = 'ORIGINAL_VALUE';
          } else {
            matchedTxt = `{{REQ_BODY_${Object.keys(matches)?.length + 1}}}`;
          }
        }
      }

      if (matchedTxt?.length) {
        matches[newPath] = matchedTxt;
        continue;
      }

      if (typeof obj[k] === 'object') {
        getAllDynamicPaths(
          newPath,
          obj[k],
          target,
          matches,
          Array.isArray(obj[k]),
          clickedPath,
          checked
        );
      }
    }
  }

  return matches;
}

function getValueByPathOld(obj: any, path: string) {
  if (!path.startsWith('[')) {
    path = path.substring(1);
  }

  return path.split('.').reduce((acc, part) => {
    if (!acc) {
      return undefined;
    }

    const arrayIndexMatch = part.match(/^\[(\d+)\]$/);
    if (arrayIndexMatch) {
      const [, index] = arrayIndexMatch;
      return acc[Number(index)];
    }

    const propertyMatch = part.match(/^(\w+)\[(\d+)\]$/);
    if (propertyMatch) {
      const [, arrayName, index] = propertyMatch;
      return acc[arrayName] ? acc[arrayName][Number(index)] : undefined;
    }

    return acc[part];
  }, obj);
}

function getValueByPath(obj: any, path: string): any {

  if (!path || typeof path !== 'string') return undefined;

  const flatKeyMatch = path.match(/^\['(.+)'\]$/);
  if (flatKeyMatch) {
    const flatKey = flatKeyMatch[1];
    return obj[flatKey];
  }


  path = path.replace(/^(\$\.|\$|\.)/, '');


  const parts = path.split('.').flatMap(part => {
    const match = part.match(/^(\w+)\[(\d+)\]$/);
    if (match) {
      const [, key, index] = match;
      return [key, Number(index)];
    }
    return part;
  });

  return parts.reduce((acc, part) => {
    if (acc == null) return undefined;
    return acc[part];
  }, obj);
}


function setValueByPath(obj: any, path: string, value: any) {
  const parts = path.split('.');
  let current = obj;
  parts.forEach((part, index) => {
    // Check if the part is an array index
    const match = part.match(/(\w+)\[(\d+)\]/);
    if (match) {
      const [, arrayName, arrayIndex] = match;
      // Initialize the array if it does not exist
      if (!current[arrayName]) {
        current[arrayName] = [];
      }

      // Navigate to the array element
      current = current[arrayName];
      if (index === parts.length - 1) {
        current[arrayIndex] = value;
      } else {
        // Initialize the object in the array if it does not exist
        if (!current[arrayIndex]) {
          current[arrayIndex] = {};
        }

        current = current[arrayIndex];
      }
    } else {
      if (index === parts.length - 1) {
        current[part] = value;
      } else {
        // Initialize the object if it does not exist
        if (!current[part]) {
          current[part] = {};
        }

        current = current[part];
      }
    }
  });
}

function normalizeJsonPath(path: string): string {
  const flatKeyMatch = path.match(/^\$\['(.+)'\]$/);
  if (!flatKeyMatch) return path;

  const flatKey = flatKeyMatch[1];

  if (!flatKey.includes('.') && !flatKey.includes('[')) {
    return `$.${flatKey}`;
  }

  return path;
}

function compareObjects(obj1: any, obj2: any, keys: string[] = []) {
  let allKeys = new Set([...keys]);

  if (!keys?.length) {
    allKeys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);
  }

  const differingKeys: any = [];

  allKeys.forEach((key) => {
    if (obj1[key] !== obj2[key]) {
      differingKeys.push(key);
    }
  });

  return differingKeys;
}

function compareProviders(
  provider1: ProviderDetails,
  provider2: ProviderDetails
): boolean {
  const fieldsToCompare = [
    'customInjection',
    'geoLocation',
    'loginUrl',
    'method',
    'url',
    'urlType',
  ];
  const bodySniffFields = ['enabled', 'regex'];
  const responseSelectionFields = ['xPath', 'jsonPath', 'responseMatch'];

  if (compareObjects(provider1, provider2, fieldsToCompare).length) {
    return true;
  }

  if (compareObjects(provider1.bodySniff, provider2.bodySniff, bodySniffFields).length) {
    return true;
  }

  if (provider1.responseSelections?.length !== provider2.responseSelections?.length) {
    return true;
  }

  for (let i = 0; i < provider1.responseSelections?.length; i++) {
    if (
      compareObjects(
        provider1.responseSelections[i],
        provider2.responseSelections[i],
        responseSelectionFields
      ).length
    ) {
      return true;
    }
  }

  try {
    const template1 = JSON.stringify(JSON.parse(provider1.bodySniff.template));
    const template2 = JSON.stringify(JSON.parse(provider2.bodySniff.template));
    if (template1 !== template2) {
      return true;
    }
  } catch {
    if (provider1.bodySniff.template !== provider2.bodySniff.template) {
      return true;
    }
  }

  return false;
}

function checkIfVariableNameExists(
  selectedInstances: SelectedInstanceType[],
  variableName: string
) {
  return !!selectedInstances.some((instance) => instance.variableName === variableName);
}

function isValidVariableName(variableName: string) {
  return /^[a-zA-Z0-9_]+$/.test(variableName);
}

/**
 * This function processes a JSON string to remove quotes around all {{REQ_BODY_N}} and to replace the last {{REQ_BODY_N}} with {{REQ_BODY_GRD}} if it exists at the end of the string.
 * @param {string} jsonString - The JSON string to be processed.
 * @returns {string} The processed JSON string.
 */
function processReqBodyInJson(jsonString: string): string {
  // Step 1: Remove quotes around all {{REQ_BODY_N}} if they exist
  const removeQuotes = (str: string) => {
    const regex = /"(\{\{REQ_BODY_\d+\}\})"/g;
    return str.replace(regex, '$1');
  };

  // Step 2: Replace {{REQ_BODY_N}} with {{REQ_BODY_GRD}} if it's at the end of the string
  const replaceLastReqBody = (str: string) => {
    const regex = /(\{\{REQ_BODY_\d+\}\})(?=\s*}?\s*$)/;
    return str.replace(regex, '{{REQ_BODY_GRD}}');
  };

  // Apply both transformations
  const withoutQuotes = removeQuotes(jsonString);
  const finalString = replaceLastReqBody(withoutQuotes);

  return finalString;
}

/**
 * This function adds quotes around all {{REQ_BODY_X}} in a JSON string, where X is any alphanumeric string.
 * @param {string} jsonString - The JSON string to be processed.
 * @returns {string} The processed JSON string with quotes around all {{REQ_BODY_X}} occurrences.
 */
function addQuotesAroundReqBody(jsonString: string): string {
  // Regular expression to match {{REQ_BODY_X}} where X is any alphanumeric string,
  // but only if it's not already enclosed in quotes
  const regex = /(?<!")\{\{REQ_BODY_[A-Za-z0-9]+\}\}(?!")/g;

  // Replace function
  const replacer = (match: string) => {
    return `"${match}"`;
  };

  // Return the modified string
  return jsonString.replace(regex, replacer);
}


function getKeyName(path: string): string {
  const flatMatch = path.match(/^\['(.+)'\]$/);
  if (flatMatch) {
    return flatMatch[1];
  }

  return path.replace(/^\$\./, '').split('.').pop() || '';
}


function flattenObject(obj: any, parent = '', res: any = {}) {
  for (let key in obj) {
    const propName = parent ? `${parent}.${key}` : key;
    if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
      flattenObject(obj[key], propName, res);
    } else {
      res[propName] = obj[key];
    }
  }
  return res;
}


function resolveJsonPathStyle(path: string, fullData: any): string {
  const flatKeys = Object.keys(flattenObject(fullData));
  if (flatKeys.includes(path)) {
    return `['${path}']`;
  }

  return `${path}`;
}

export {
  search,
  escapeRegExp,
  createXPathFromElement,
  getMatchIndexes,
  getUniqueItems,
  getValuePositionInJson,
  getAllPaths,
  getValueByPath,
  getAllDynamicPaths,
  setValueByPath,
  compareProviders,
  compareObjects,
  checkIfVariableNameExists,
  isValidVariableName,
  processReqBodyInJson,
  addQuotesAroundReqBody,
  normalizeJsonPath,
  getKeyName,
  flattenObject,
  resolveJsonPathStyle
};
